import {jwtDecode} from 'jwt-decode';

export const getPermissions = () => {
    try {
        const token = localStorage.getItem("accessToken");

        if (!token) return [];

        const decoded = jwtDecode(token);
        return decoded.permissions || [];
    } catch (error) {
        console.error("Error getting permissions:", error);
        localStorage.removeItem("accessToken");
        return []; // Return empty array to prevent further execution
    }
};

export const hasPermission = (permission) => {
    const permissions = getPermissions();
    //console.log("Permissions: ", permissions);
    return permissions && permissions.includes(permission);
};
export const getUsername = () => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        const decoded = jwtDecode(token);
        return decoded.user;
    }
    return null;
};
